import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LazySection } from './LazySection';
const faqs = [{
  q: '¿Esto es lo mismo que las constelaciones familiares?',
  a: '<strong>No.</strong> Las constelaciones son grupales y de exposición pública. Este sistema es un <strong>proceso estructurado, individual y privado</strong>, con base en epigenética y psicología transgeneracional (estudios de Emory y Mount Sinai). Lo hacés sola y a tu ritmo.'
}, {
  q: '¿Necesito conocimientos de psicología?',
  a: '<strong>Para nada.</strong> El lenguaje es accesible, los ejercicios están guiados paso a paso y hay ejemplos resueltos. Solo necesitás disposición y honestidad con vos misma.'
}, {
  q: '¿Puedo hacerlo sin un profesional al lado?',
  a: '<strong>Sí.</strong> Está diseñado para trabajarlo de forma autónoma. No reemplaza la terapia, la complementa. Muchas lo usan para llegar a sesión con el mapa ya armado.'
}, {
  q: 'Ya compré cursos y no funcionaron. ¿Por qué este es distinto?',
  a: 'Porque los cursos te dan conocimiento; <strong>este te da herramientas aplicables.</strong> Los libros explican, este sistema te hace hacer: trazás tu genograma, hacés las cartas, completás el diario. Cuando terminás, algo cambió.'
}, {
  q: 'Me da miedo lo que pueda encontrar. ¿Es normal?',
  a: '<strong>Completamente normal.</strong> Ese miedo indica que hay algo importante por mirar. El sistema está diseñado en etapas, con herramientas de contención. No enfrentás nada de golpe.'
}, {
  q: '¿Cuánto tiempo necesito?',
  a: 'Con <strong>20–30 minutos al día</strong> avanzás muy bien. No hay fechas ni urgencias, el acceso es para siempre. El primer momento de claridad suele aparecer en los primeros 90 minutos.'
}, {
  q: '¿Sirve si no vivo en Argentina?',
  a: '<strong>Sí.</strong> Los patrones generacionales son universales. El sistema está en español neutro y aplica a cualquier dinámica familiar.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un correo con el acceso. <strong>Todo es 100% digital</strong>, podés descargarlo o trabajarlo desde cualquier dispositivo. Sin esperas y con total privacidad.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <LazySection className="bg-cream !py-[80px] md:!py-[100px]" data-id="element-138">
      <div className="container-custom" data-id="element-139">
        <div className="text-center" data-id="element-140">
          <span className="eyebrow" data-id="element-141">Antes de decidir</span>
        </div>
        <h2 className="text-center text-[clamp(30px,4.5vw,42px)] mb-10" data-id="element-142">
          Las preguntas que <em data-id="element-143">ya te estás haciendo</em>
        </h2>

        <div className="max-w-[780px] mx-auto" data-id="element-144">
          {faqs.map((faq, i) => <div key={i} className="border-b border-border py-5" data-id="element-145">
              <button onClick={() => toggleFAQ(i)} className="w-full text-left font-serif text-[19px] font-medium cursor-pointer flex justify-between items-start gap-5 bg-transparent border-none p-0 text-ink" data-id="element-146">
                {faq.q}
                <span className={`text-[26px] text-gold-dark font-light leading-none shrink-0 transition-transform duration-250 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-147">
                  +
                </span>
              </button>
              <AnimatePresence data-id="element-148">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-149">
                    <p className="mt-3.5 text-ink-soft text-[15px] leading-[1.65] pb-2" dangerouslySetInnerHTML={{
                __html: faq.a
              }} data-id="element-150" />
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </LazySection>;
}